import { styled } from '@acko-tech/building-blocks.ui.common';
import { INTERNATIONAL_DESKTOP_ASSETS } from 'src/common/utils/config';

export const HelpPageContainer = styled.div`
  padding: 20px;
  padding-top: 15px;
  max-width: ${(props) => props.maxWidth || '480px'};
  margin: ${(props) => props.margin || 'auto'};
  padding: ${(props) => props.padding || '20px'};

  @media screen and (min-width: 768px) {
    padding: 0;
    max-width: unset;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 10px;
  width: inherit;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin-top: 16px;

  @media screen and (min-width: 768px) {
    font-weight: 700;
    font-size: 1.625rem;
    line-height: 2.25rem;
  }
`;

export const Desc = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 10px 0 6px 0;
`;

export const SkeletonContainer = styled.div`
  padding: 16px 0 32px 0;
`;

export const IconContainer = styled.div`
  cursor: pointer;
`;

export const HelpNavbar = styled.div`
  @media screen and (min-width: 768px) {
    max-width: 1200px;
    margin: auto;
    padding: 24px 20px;
    background: white;
  }
`;

export const HelpContent = styled.div`
  @media screen and (min-width: 768px) {
    padding: 24px 20%;
    background: url(${INTERNATIONAL_DESKTOP_ASSETS.JOURNEY_BACKGROUND});
    background-repeat: no-repeat;
    background-color: #f8fdff;
    background-size: 100%;
    ${(props) => props && props.contentStyles};
  }
`;
